<template>
  <a-card :bordered="false" class="dashboard-bar-line header-solid">
    <div class="title_box">使用趋势</div>
    <div id="demo" style="width: 100%; height: 385px"></div>
  </a-card>
</template>

<script>
// Bar chart for "Active Users" card.
import ChartLine from "../Charts/ChartLine";

export default {
  components: {
    ChartLine,
  },
  props: {
    MonthlyUsage: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Data for line chart.
      lineChartData: {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
          {
            label: "Mobile apps",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#1890FF",
            borderWidth: 3,
            data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
            maxBarThickness: 6,
          },
        ],
      },
    };
  },
  watch: {
    MonthlyUsage() {
      let xAxisData = [],
        seriesData = [];
      this.MonthlyUsage.forEach((item) => {
        xAxisData.push(item.usageDate);
        seriesData.push(item.usageCount);
      });

      this.drawChart(xAxisData, seriesData);
    },
  },
  mounted() {},
  methods: {
    drawChart(xAxisData = [], seriesData = []) {
      //2. 基于准备好的dom，初始化echarts实例
      //此处的意思就是，对 demo 元素 进行图表初始化的相关操作
      var myChart = this.$echarts.init(document.getElementById("demo"));
      //3. 指定图表的配置项和数据
      //该处就是图表内容，在官网的示例里面，要复制过来到项目里面的也是这一块内容
      var option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["使用数量"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "30px",
          containLabel: false,
        },

        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "使用数量",
            data: seriesData,
            type: "line",
            smooth: true,
          },
        ],
      };
      //4.使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
<style lang="scss">
.title_box {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 80px 10px 10px;
  font-weight: 700;
  font-size: 20px;
  margin-left: 0px;
  &::after {
    position: absolute;
    left: 0;
    content: "";
    width: 5px;
    height: 20px;
    background: #2a82e4;
  }
}
.dashboard-bar-line {
  padding: 0;
}
</style>
